<template>
  <div>

    <br />
    <router-link :to="{ name: 'EcoloDefiPage' }">
      Retour à la page de l'Écolo-défi
    </router-link>

    <div v-html="html"></div>

    <template v-if="loaded === false">
      <h3>Page non trouvée</h3>
    </template>

    <router-link :to="{ name: 'EcoloDefiPage' }">
      Retour à la page de l'Écolo-défi
    </router-link>
    <br /><br />

  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    name: 'EcoloDefiSingle',
    data() {
      return {
        year: this.$route.params.year,
        html: null,
        loaded: null
      };
    },
    async mounted() {
      const data = await fetch(this.path());
      if (!data.ok) {
        this.loaded = false;
      }
      else {
        this.html = await data.text();
      }
    },
    methods: {
      path() {
        if (!_.isString(this.year) || _.size(this.year) !== 9) {
          this.year = '2018-2019';
        }
        return '/pages/ecolo_defi/' + this.year + '.html';
      }
    }
  };
</script>

<style scoped></style>
